<template>
  <a-modal
    v-model="showProfileDrawer"
    width="100%"
    :closable="false"
    :maskClosable="true"
    :footer="null"
    :bodyStyle="{ padding: 0 }"
    style="top: 10px"
    class="ant-modal-custom"
  >
    <slot></slot>
  </a-modal>
</template>

<script>
export default {
  name: "Drawer",
  data() {
    return {
      showProfileDrawer: false,
      isMobile: false
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    show() {
      this.showProfileDrawer = true;
    },
    close() {
      this.showProfileDrawer = false;
    },
    handleResize() {
      if (window.innerWidth < 700) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
        this.showProfileDrawer = false;
      }
    }
  }
};
</script>

<style lang="scss">
.ant-modal-custom .ant-modal-wrap .ant-modal {
  position: absolute;
  padding: 0px;
  top: initial;
  bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/DrawerModal.vue